/**
 * Cart Service
 * API methods for cart operations (requires authentication)
 */

import api from '../utils/api';

export const cartService = {
  /**
   * Get customer's cart
   * @returns {Promise} API response with cart items
   */
  getCart: () => {
    return api.get('/customer/cart');
  },

  /**
   * Add food/combo item to cart (requires storeId)
   * @param {Object} itemData
   * @returns {Promise} API response
   */
  addFoodItem: (itemData) => {
    return api.post('/customer/cart/add-food', itemData);
  },

  /**
   * Add merchandise to cart (no storeId needed)
   * @param {Object} itemData
   * @returns {Promise} API response
   */
  addMerchandiseItem: (itemData) => {
    return api.post('/customer/cart/add-merchandise', itemData);
  },

  /**
   * Add gift card to cart
   * @param {Object} itemData - { itemId, quantity, selectedValue, recipient }
   * @returns {Promise} API response
   */
  addGiftCardItem: (itemData) => {
    return api.post('/customer/cart/add-gift-card', itemData);
  },

  /**
   * Update cart item quantity
   * @param {string} cartItemId - Cart item ID
   * @param {number} quantity - New quantity
   * @returns {Promise} API response
   */
  updateItem: (cartItemId, quantity) => {
    return api.put(`/customer/cart/item/${cartItemId}`, {
      quantity
    });
  },

  /**
   * Remove item from cart
   * @param {string} cartItemId - Cart item ID
   * @returns {Promise} API response
   */
  removeItem: (cartItemId) => {
    return api.delete(`/customer/cart/item/${cartItemId}`);
  },

  /**
   * Clear entire cart
   * @returns {Promise} API response
   */
  clearCart: () => {
    return api.delete('/customer/cart');
  },
  /**
   * Merge guest cart with user cart
   * @param {Array} cartItems - Array of guest cart items
   * @returns {Promise} API response
   */
  mergeCart: (cartItems) => {
    return api.post('/customer/cart/merge', { items: cartItems });
  },

  applySpecialOffer: (offerId, customerId, cartItems = []) => {
    return api.post('/offers/apply-special', { offerId, customerId, cartItems });
  },

  removeSpecialOffer: (offerId, customerId) => {
    return api.post('/offers/remove-special', { offerId, customerId });
  },
};

export default cartService;
